import getSessionContext from 'src/utils/context/getSessionContext'
import { make } from 'vuex-pathify'
import rpc from '../../api/rpc'

const state = {
  users: null
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  async usersFetch ({ commit, rootState }) {
    const response = await rpc('users.users_fetch', { org_id: getSessionContext().org_id })
    if (response) {
      commit('SET_USERS', response)
      return true
    }
  },

  async usersDelete ({ commit, state }, id) {
    const response = await rpc('users.users_delete', id)
    if (response && response.result === 'Success') {
      commit('SET_USERS', state.users.filter(r => r.id !== id))
      return true
    }
  }
}

export default { state, actions, mutations, namespaced }
